<template>
  <transition name="fade">
    <div class="toast-box" v-show="visible">
      <div class="toast">
        <p v-html="message"></p>
      </div>
      <div class="toast-layer" :style="'background-color: rgba(0, 0, 0, ' + opacity + ');'" v-show="visible"></div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      type: 0,
      visible: false,
      message: "",
      opacity: 0,
      icon: ""
    };
  },

  updated() {
  },
  mounted() {

  }
};

</script>
<style scoped="scoped" lang="less">
.toast-box {
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  pointer-events: none;
}
.toast {
  box-sizing: border-box;
  padding: 8px 16px;
  min-height: 40px;
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 5px;
      max-width: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 45px;
    height: 45px;
    margin-bottom: 6px;
    border-radius: 8px;
  }
  p {
    line-height: 20px;
    max-width: 100%;
    word-wrap: break-word;
    word-break: break-all;
    text-align: center;
    font-size: 12px;
    color: #fff;
    flex-shrink: 0;
  }
  i {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    border-radius: 50%;
    position: relative;

    .bg {
      top: 2.5px;
      left: 2.5px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: #fff;
      position: absolute;
      z-index: -1;
    }
 
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.toast-layer {
  z-index: 9;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

 .ani-loading {
    padding-bottom: 7px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    display: inline-block;
    .ing {
      
      width: 24px;
      height: 24px;
      margin: 0 auto;
      /deep/ svg {
        display: block;
        
      
      }
    }
  }
</style>
